import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  sideMenu: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "100%",
    height: "100%",
    overflowY: "auto",
    backgroundColor: "transparent",
    zIndex: theme.zIndex.drawer + 2,
    transition: "transform 0.3s ease-in-out",
    borderRight: `1px solid ${theme.palette.border.primary}`,
    borderRadius: theme.borderRadius[0],
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  hidden: {
    transform: "translateX(100%)",
    visibility: "hidden",
    opacity: 0,
  },
  sideMenuContent: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    background: "inherit",
  },
}));
